module.exports = __webpack_public_path__ + "30a535e38d924938cf5bdefb8c93cc67.svg";